module.exports = __webpack_public_path__ + "6c018cb0a60f672b2a27d2511cc9e8a0.svg";